import { createContext, useContext } from 'react';

type TransactionsProcessingType = {
  resendTx: (hash: string) => void;
};

export const TransactionsProcessingContext =
  createContext<TransactionsProcessingType>({
    resendTx: () => undefined,
  });

export const useTransactionsProcessing = (): TransactionsProcessingType =>
  useContext(TransactionsProcessingContext);
